import {Injectable} from '@angular/core';

import {Util} from '../app/util';

import {StorageService} from "../providers/storage-service";
import {MessageService} from "../providers/message-service";
import {Observable} from "rxjs/Observable";

@Injectable()
export class PushRepository {

    constructor(public util: Util, public storageService: StorageService,
                public messageService: MessageService) {

    }


    /* ISSO ESTAVA NO HANDAPP MAIN

    //Push Badge - Forward
    pushBadge(notification) {

        if (notification.additionalData.badgeObject && notification.additionalData.badgeObject.id) {

            this.storageService.get('badgesObj').subscribe(badgesObj => {

                if (!badgesObj) badgesObj = [];

                badgesObj.push(notification.additionalData.badgeObject);
                this.storageService.set('badgesObj', badgesObj).subscribe(data => this.messageService.get('badge.pushed').next());

            });

        }

    }

    */



    //APP-PUBLISH - EXCLUIR ESSE ARQUIVO NAO ESTA USANDO NADA DISSEO MAIS
    badgeCount(badges: string[]): Observable<any> {

        return Observable.create(observer => {

            let badgesCount = 0;

            this.storageService.get('badgesObj').subscribe(badgesObj => {

                if (!badgesObj) badgesObj = [];

                badgesCount = 0;
                for (let a in badgesObj) {
                    if (badges.indexOf(badgesObj[a].id) >= 0) badgesCount += parseInt(badgesObj[a].sum);
                }

                badgesCount = Math.max(badgesCount, 0);

                observer.next(badgesCount);
                observer.complete();

            });

        });

    }

    badgeDel(badges: string[]): Observable<any> {

        return Observable.create(observer => {

            this.storageService.get('badgesObj').subscribe(badgesObj => {

                // remove itens dos mesmos ids do clicado
                badgesObj = badgesObj.filter(badgeObject => (badges.indexOf(badgeObject.id) < 0));

                this.storageService.set('badgesObj', badgesObj).subscribe(data => {

                    this.messageService.get('badge.update').next();
                    observer.complete();

                });

            });

        });

    }

}



// WEBPACK FOOTER //
// ./src/repositories/push-repository.ts